import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../../images/logo_biojeck.png";
import { FaSignOutAlt, FaBars, FaTimes } from "react-icons/fa";
import "./Header.css";

function Header({ onLogout }) {
  const ROLE = JSON.parse(localStorage.getItem("user"))[0].role;
  const IDENTITY_NUMBER = JSON.parse(localStorage.getItem("user"))[0].identity_number;
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false); // Estado para el menú hamburguesa
  const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    getStateEmployee(IDENTITY_NUMBER);
  }, []);

  const getStateEmployee = (identity_number) => {
    fetch(`${API_URL}/employee/${identity_number}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    })
      .then((response) => response.json())
      .then((result) => {
        if (result && result?.employee) {
          if(result?.employee.state_employee === 'INACTIVO'){
            handleLogout();
          }
          
        } else {
          console.log("No se encontro el insumo");
        }
      })
      .catch(() => {
        console.log("Error de servidor");
      });
  };

  const handleLogout = () => {
    localStorage.removeItem("user"); // Eliminar usuario del almacenamiento
    onLogout(); // Actualizar estado global en App.js
    navigate("/login"); // Redirigir al login
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen); // Alternar la visibilidad del menú
  };

  return (
    <header className="header">
      <nav>
        <div className="logo">
          <Link to="/home">
            <img src={Logo} alt="BioJeck Logo" />
          </Link>
        </div>
        {/* Menú para escritorio */}
        <div className={`menu ${isMenuOpen ? "active" : ""}`}>
          {ROLE === "administrador" && (
            <>
              <Link to="/employes" onClick={toggleMenu}>Empleados</Link>
              <Link to="/control-panel" onClick={toggleMenu}>Panel de control</Link>
            </>
          )}
          <Link to="/invoices" onClick={toggleMenu}>Facturación</Link>
          {(ROLE === "apoyo administrativo" || ROLE === "administrador") && (
            <>
              <Link to="/contracts" onClick={toggleMenu}>Contratos</Link>
              <Link to="/consult-invoices" onClick={toggleMenu}>Consultar facturas</Link>
            </>
          )}
          {isMenuOpen && (
            <>
              <button className="btn-logout-mobile" onClick={handleLogout}>
                Cerrar sesión
              </button>
            </>
          )}
        </div>
        {/* Ícono de cerrar sesión */}
        <div className="logout-icon">
          <FaSignOutAlt onClick={handleLogout} size={24} />
        </div>
        {/* Ícono de hamburguesa */}
        <div className="hamburger-icon" onClick={toggleMenu}>
          {isMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
        </div>
      </nav>
    </header>
  );
}

export default Header;
